import gql from "graphql-tag";

export const ORDER_PRODUCTS_SEARCH = gql`
  query orderProductsSearch(
    $limit: Int,
    $offset: Int,
    $orderBy: String,
    $orderDirection: String,
    $filters: ProductFilter
  ) {
    products(
      limit: $limit,
      offset: $offset,
      orderBy: $orderBy,
      orderDirection: $orderDirection,
      filters: $filters,
    ){
      id
      number
      name
      description
      productGroup {
        id
        name
      }
      productPrices {
        id,
        purchasePrice,
        salePrice
        validTo,
        validFrom,
        contributionMargin,
        contributionMarginPercentage,
      }
      unitOfMeasureCode
      supplierUnit {
        id
        name
      }
      vatRateSymbol
      taxExemptionReason
      car {
        id
        registrationNumber
        name
      }
      project {
        id
        code
        name
      }
      department {
        id
        code
        name
      }
    }
  },
`;
